import React, { Fragment } from "react";
import NewCricBuddyPortfolioHeroSection from "./NewCricBuddyPortfolioHeroSection";
import "../../Css/CB.css";
import A2PortfolioTechStack from "../Components/A2PortfolioTechStack";
import NewCricBuddyPortfolioClientRequirements from "./NewCricBuddyPortfolioClientRequirements";
import NewCricBuddyPortfolioSolution from "./NewCricBuddyPortfolioSolution";
import NewCricBuddyPortfolioUserSideFeatures from "./NewCricBuddyPortfolioUserSideFeatures";
import NewCricBuddyPortfolioVenueSideFeatures from "./NewCricBuddyPortfolioVenueSideFeatures";
import NewCricBuddyPortfolioContactUs from "./NewCricBuddyPortfolioContactUs";
import HelmetMetaTag from "../Components/HelmetMetaTag";

export default function NewCricBuddyPortfolioDashboard() {
  const slides = [
    {
      title: "Frontend",
      logos: [
        "frontendlogo1.png",
        "frontendlogo5.png",
        "frontendlogo6.png",
        "frontendlogo7.png",
      ],
    },
    {
      title: "Backend",
      logos: ["backendlogo1.png", "backendlogo3.png", "Express.png"],
    },
    {
      title: "Database",
      logos: ["database1white.png"],
    },
    {
      title: "Payment & API Integration",
      logos: ["Gupshup.png", "RazorPay.png", "witAi.png"],
    },
  ];
  return (
    <div className="bg-181818">
      <HelmetMetaTag
        titleName="Online sports venue booking platform - SprigStack"
        desc="Cricbuddy is an online sports venue booking platform. Users can easily book venues & venue owners can manage bookings, prices & revenue in a single place."
        canonical={window.location.href}
        ogtitle="Online sports venue booking platform - SprigStack"
        ogdesc="Cricbuddy is an online sports venue booking platform. Users can easily book venues & venue owners can manage bookings, prices & revenue in a single place."
        ogtype="website"
        ogurl={window.location.href}
      />
      <NewCricBuddyPortfolioHeroSection />
      <A2PortfolioTechStack
        slides={slides}
        headingColor="clr-fff"
        Color="clr-b-fff"
        strokeTextColor="portfolio-stroke-text-color"
      />
      <NewCricBuddyPortfolioClientRequirements />
      <NewCricBuddyPortfolioSolution />
      <NewCricBuddyPortfolioUserSideFeatures />
      <NewCricBuddyPortfolioVenueSideFeatures />
      <NewCricBuddyPortfolioContactUs />
    </div>
  );
}
